import * as XLSX from 'xlsx';

// ✅ Excel Serial Date Conversion Helper
// function convertToExcelDate(jsDate) {
//     const epoch = Date.UTC(1899, 11, 30);
//     const excelTime = (jsDate.getTime() - epoch) / (1000 * 60 * 60 * 24);
//     return Math.floor(excelTime);
// }

function convertToExcelDate(jsDate) {
    // Create a UTC date at midnight (no time zone offset)
    const utcDate = Date.UTC(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate());
    const epoch = Date.UTC(1899, 11, 30);
    const excelTime = (utcDate - epoch) / (1000 * 60 * 60 * 24);
    return Math.floor(excelTime);
}


// ✅ Generic Excel Export Function
export const exportToExcel = ({
    data = [],
    fileName = 'Exported_Report.xlsx',
    sheetName = 'Sheet1',
    columns = [],
    dateColumnIndexes = [],
    numberColumnIndexes = []
}) => {
    // Format and clean data
    const formattedData = data.map(row => {
        const formattedRow = {};
        columns.forEach((col, index) => {
            let value = row[col.key];

            // Convert to Excel date if it's a date column
            if (dateColumnIndexes.includes(index) && value) {
                value = convertToExcelDate(new Date(value));
            }

            // Parse number if it's a number column (e.g., 'WIP' should stay string)
            else if (numberColumnIndexes.includes(index)) {
                value = isNaN(parseFloat(value)) ? value : parseFloat(value);
            }

            formattedRow[col.header] = value;
        });
        return formattedRow;
    });

    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const range = XLSX.utils.decode_range(worksheet['!ref']);

    // Apply formatting for date columns
    for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (const colIndex of dateColumnIndexes) {
            const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
            const cell = worksheet[cellAddress];
            if (cell && typeof cell.v === 'number') {
                cell.t = 'n';
                cell.z = 'dd-mm-yyyy';
            }
        }
    }

    // Apply styling to headers
    for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = {
            alignment: { vertical: 'center', horizontal: 'center' },
            font: { bold: true },
            border: {
                top: { style: 'thin' }, bottom: { style: 'thin' },
                left: { style: 'thin' }, right: { style: 'thin' },
            },
        };
    }

    // Add borders to all cells
    for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
            if (!worksheet[cellAddress]) continue;
            worksheet[cellAddress].s = {
                ...worksheet[cellAddress].s,
                border: {
                    top: { style: 'thin' }, bottom: { style: 'thin' },
                    left: { style: 'thin' }, right: { style: 'thin' },
                },
            };
        }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Export file
    XLSX.writeFile(workbook, fileName);
};
